/**
 * @file ChatWindowEmpty.tsx
 * @description «Диалог не выбран» в правой зоне окна (chat-window-design.md
 * §5): «Выберите диалог, чтобы прочитать переписку и ответить» и, если есть,
 * «Непрочитанных диалогов: 2».
 */

import { MessagesSquare } from "lucide-react";

import { CHAT_TEXT } from "./chat-texts";

export function ChatWindowEmpty({ unread }: { unread: number }) {
  return (
    <div className="flex min-w-0 flex-1 flex-col items-center justify-center gap-2 px-6 text-center">
      <MessagesSquare className="size-8 text-on-surface-variant" aria-hidden />
      <p className="max-w-[36ch] text-sm text-on-surface-variant">{CHAT_TEXT.pickConversation}</p>
      {unread > 0 ? <p className="text-sm font-medium text-on-surface">{CHAT_TEXT.unreadConversations(unread)}</p> : null}
    </div>
  );
}
